<template>
  <div
    type="button"
    :class="getClasses"
    class="border-gray-300 cursor-pointer  inline-flex rounded-md shadow-sm select-noneitems-center border  text-sm leading-4 font-medium focus:outline-none
      focus:border-blue-300 focus:shadow-outline-blue  transition ease-in-out duration-150"
    @click="emitClick"
  >
    <div v-if="!loading">
      {{ text }} <i class="far fa-chevron-down ml-1" />
    </div>
    <div
      v-else
      class="-mt-1"
    >
      <LoadingSpinner :white="false" />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/app/shared/components/base/loading/loadingSpinner.vue';

export default {

  components: {
    LoadingSpinner,
  },

  props: {
    text: {
      type: String,
      default: '',
    },
    padding: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getClasses() {
      let classes = '';

      if (this.padding !== undefined) {
        classes += `${this.padding} `;
      } else {
        classes += 'px-3 py-2 ';
      }

      return classes;
    },
  },

  methods: {
    emitClick() {
      if (!this.disabled && !this.loading) {
        this.$emit('click');
      }
    },
  },
};
</script>
